document.addEventListener("DOMContentLoaded", function () {

    // index claim - otevírání formulářů
    //=========================

    let buttons = document.querySelectorAll('[data-index-claim-button]'),
        picture = document.querySelector('[data-index-claim-picture]'),
        closeButton = document.querySelectorAll('[data-index-claim-close]');

    let timeout = 0;

    /* is-last-visible - třída která má držet dosavadní stav než se vykreslí nový obsah kvůli efektnímu najíždění formuláře přes fotku */
    const classLastVisible = 'is-last-visible',
        classIsVisible = 'is-visible';

    setTimeoutDelay();

    buttons.forEach(button => {
        button.addEventListener('click',  () =>  {
            removeActiveClassFromButtons();
            button.classList.add('is-active');
            document.querySelector('[data-index-claim-content].is-visible').classList.add(classLastVisible);
            document.querySelector('#' + button.dataset.indexClaimId).classList.add(classIsVisible);
            removeVisibility();
        });
    });

    closeButton.forEach(button => {
        button.addEventListener('click', () => {
            close(button.parentElement);
            removeActiveClassFromButtons();
        });
    });

    function removeActiveClassFromButtons() {
        buttons.forEach(button => {
            button.classList.remove('is-active');
        });
    }

    function removeVisibility() {
        setTimeout(() => {
            document.querySelector('[data-index-claim-content].' + classLastVisible).classList.remove(classLastVisible, classIsVisible);
        }, timeout);
    }

    function close(buttonParentEl) {
        buttonParentEl.classList.add(classLastVisible);
        picture.classList.add(classIsVisible);
        removeVisibility();
    }

    function setTimeoutDelay() {
        if (window.innerWidth > 991) {
            timeout = 250;
        } else {
            timeout = 0;
        }
    }

    window.addEventListener('resize', () => {
        setTimeoutDelay();
    });
});